import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import {
  combineLatest,
  filter,
  map,
  pipe,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/last-seen-helper/graphql';
import { LastSeenServiceService } from 'ZalamoLibrary/src/lib/zalamo/last-seen-helper/last-seen-service.service';
import { GetPrivateSessionsGQL } from '../../../../graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-last-seen-private-sessions',
  templateUrl: './last-seen-private-sessions.component.html',
  styleUrls: ['./last-seen-private-sessions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LastSeenPrivateSessionsComponent implements OnInit {
  lastSeen$ = combineLatest([
    this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.getPrivateSessionsGQL
          .watch({ variables: { organizationId } })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['getPrivateSessions']),
          ),
      ),
    ),
    this.lastSeenServiceService.getLastObjectViews(ZalamoObject.PrivateSession),
  ]).pipe(
    map(([allSessions, lastSeenSessions]) =>
      lastSeenSessions
        .map((privateSessionId) => ({
          privateSessionId,
          name: allSessions.find(
            (session) => session.privateSessionId === privateSessionId,
          )?.name,
        }))
        .filter((session) => !!session.name),
    ),
  );

  constructor(
    private lastSeenServiceService: LastSeenServiceService,
    private getPrivateSessionsGQL: GetPrivateSessionsGQL,
    private organizationService: OrganizationService,
    private zalamoDialogService: ZalamoDialogService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  async addSession() {
    console.log('Add New private Session');
    const { PrivateSessionStepContainerComponent } =
      await import('../../../modules/private-sessions/components/add-new-steps/private-session-step-container/private-session-step-container.component');
    const ref = this.zalamoDialogService.openFull(
      PrivateSessionStepContainerComponent,
      { isBare: true },
    );
    ref.componentInstance.finished
      .pipe(
        takeUntil(ref.afterClosed()),
        tap(() => ref.close()),
      )
      .subscribe();
    this.router.events
      .pipe(takeUntil(ref.beforeClosed()))
      .subscribe(() => ref.close());
  }
}
